import { MarketplaceSquareLogo } from 'src/components/common/MarketplaceSquareLogo';
import { TableCellDiv } from 'src/core/ui/TableCellDiv';

import { SaleWithEvent } from '../SalesTable.type';
import * as styles from './MarketplaceInfoCell.css';

export const MarketplaceInfoCell = ({
  sale: {
    sale: { mkp },
  },
  useV2Style = false,
}: {
  sale: SaleWithEvent;
  useV2Style?: boolean;
}) => {
  return (
    <TableCellDiv
      align="left"
      showTooltip={false}
      style={{ height: '100%' }}
      wrap={'wrap'}
    >
      <div
        className={
          useV2Style
            ? styles.marketplaceLogoContainerV2
            : styles.marketplaceLogoContainer
        }
        title={mkp?.toString()}
      >
        <MarketplaceSquareLogo marketplace={mkp} size={16} />
      </div>
    </TableCellDiv>
  );
};
